export default __webpack_public_path__ + "static/media/Emoji_Bar_Hearts.2193d6dc.svg";